export const composeFormData = function (data) {
  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
}

export const buildFormData = function (formData, data, parentKey) {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof Blob)) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
    return;
  }

  if (data != null) {
    if (typeof data === 'boolean') {
      data = data ? 1 : 0;
    }

    formData.append(parentKey, data);
  }
}

export default {
  composeFormData,
  buildFormData,
};
